import React, { useEffect, useRef } from 'react';
import { Virtuoso } from 'react-virtuoso';
import styled from 'styled-components';
import { Card } from '@material-ui/core';
import { FormSection } from './components';
import { useFormContext } from './FormContext';
const StyledDiv = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .form-sections {
    flex: 1;
  }
  .card {
    margin-bottom: 24px;
    padding: 24px;
  }
`;
export const FormViewer = ({ statePath, values, disabled, onInit, onChange }) => {
    const { formSections } = useFormContext();
    const formContext = useFormContext();
    const { stateMachine, formValues, setFormValues } = formContext;
    const mountRef = useRef(false);
    const onInitRef = useRef(onInit);
    const onChangeRef = useRef(onChange);
    const previousFormValues = useRef(formValues);
    const previousStatePath = useRef(statePath);
    // initial values load
    useEffect(() => {
        if (values) {
            setFormValues(values);
        }
    }, [values, setFormValues]);
    // start the state machine on mount
    useEffect(() => {
        var _a;
        if (!stateMachine)
            return;
        const stateNode = statePath
            ? stateMachine.getStateNode(statePath)
            : undefined;
        if (!mountRef.current) {
            mountRef.current = true;
            formContext.formValues = values || formValues;
            if (statePath && stateNode) {
                stateMachine.resume({ path: statePath, context: formContext });
            }
            else {
                stateMachine.start(formContext);
            }
            (_a = onInitRef.current) === null || _a === void 0 ? void 0 : _a.call(onInitRef, formContext);
        }
        else if (statePath &&
            stateNode &&
            previousStatePath.current !== statePath) {
            stateMachine.resume({ path: statePath, context: formContext });
        }
        previousStatePath.current = statePath;
    }, [stateMachine, formContext, values, statePath, formValues]);
    useEffect(() => {
        var _a;
        if (formValues && formValues !== previousFormValues.current) {
            previousFormValues.current = formValues;
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, formValues);
        }
    }, [formValues]);
    return (React.createElement(StyledDiv, { className: 'form-viewer' },
        React.createElement(Virtuoso, { className: 'form-sections', data: formSections, itemContent: (index, stateNode) => (
            // NOTE: Do not place any elements adjacent to FormSectionEditor;
            // otherwise, the sorting will break
            React.createElement(Card, { className: 'card' },
                React.createElement(FormSection, { hideTransitions: true, disabled: disabled, key: stateNode.name, stateNode: stateNode }))) })));
};
export default FormViewer;
//# sourceMappingURL=FormViewer.js.map